import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { ToasterService } from '../../_services/toaster.service';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthenicationService} from '../../_services/authenication.service';
import { PricesService } from "../../_services/prices.service";

import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import {ExcelServicesService} from "../../_services/excel-services.service";

@Component({
  selector: 'app-api-keys-list',
  templateUrl: './api-keys-list.component.html',
  styleUrls: ['./api-keys-list.component.css']
})
export class ApiKeysListComponent implements OnInit {

  returnUrl: string;
  userdetaild: string;
  apilist: any[] = [];
  ApiListdata: any[] = [];


  constructor(private formBuilder: FormBuilder, private router: Router, private route: ActivatedRoute, private toaster: ToasterService, private authenicationService: AuthenicationService, private pricesService: PricesService, private spinnerService: Ng4LoadingSpinnerService, private excelService:ExcelServicesService) { }

  exportAsXLSX():void {
    this.spinnerService.show();
    this.excelService.exportAsExcelFile(this.ApiListdata, 'ApiListdata');
    this.spinnerService.hide();
  }

  ngOnInit() {
    this.userdetaild = this.authenicationService.userDetails();
    if (!this.userdetaild) {
      this.router.navigate(['/login']);
    }

    if (!this.userdetaild || this.userdetaild['users_usertype'] == 'employee2') {
      this.router.navigate(['/']);
    }



    this.getApiKeyList();
  }

  getApiKeyList() {
    this.pricesService.getApiKeyList()
      .subscribe(
        (data: any) => {
          console.log(data.ResponseCode);
          if (data && data.ResponseCode === '200') {
            this.spinnerService.hide();
            this.apilist = data.Data;

            this.apilist.forEach((row: any) => {
              const gstdata = {
                company_name: (row['company_name'])?row['company_name']:'',
                company_api_key: (row['company_api_key'])?row['company_api_key']:'',
              };
              this.ApiListdata.push(gstdata);
            });
          } else {
            this.spinnerService.hide();
            this.toaster.showError('Get Api Key', data.ResponseMessage);
          }
        },
        error => {
          this.spinnerService.hide();
          this.toaster.showError('Get Api Key', error);
        });
  };


  deleteApiKey(id) {
    let str = 'Are You Sure to Proceed';
    if(confirm(str)) {
      this.spinnerService.show();
      let payload = {
        id: id
      };
      this.pricesService.deleteApiKey(payload)
        .subscribe(
          (data: any) => {
            console.log(data.ResponseCode);
            if (data && data.ResponseCode === '200') {
              this.spinnerService.hide();
              this.reloadComponent();
              this.toaster.showSuccess('Delete Api Key', data.ResponseMessage);
            } else {
              this.spinnerService.hide();
              this.toaster.showError('Delete Api Key', data.ResponseMessage);
            }
          },
          error => {
            this.spinnerService.hide();
            this.toaster.showError('Delete Api Key', error);
          });
    }

  }

  reloadComponent() {
      this.router.routeReuseStrategy.shouldReuseRoute = () => false;
      this.router.onSameUrlNavigation = 'reload';
      this.router.navigate(['/api-key-list']);
  }

}
